export const safeSignalPeer = (peer, signal, label = "peer") => {
    if (!peer || peer.destroyed) {
        return false;
    }

    try {
        peer.signal(signal);
        return true;
    } catch (error) {
        console.log(`[${label}] Failed to signal peer:`, error?.message || error);
        return false;
    }
};

export const destroyPeer = (peer, label = "peer") => {
    if (!peer || peer.destroyed) {
        return;
    }

    try {
        peer.destroy();
    } catch (error) {
        console.log(`[${label}] Failed to destroy peer:`, error?.message || error);
    }
};

export const destroyPeerCollection = (peerEntries = [], label = "peer-collection") => {
    peerEntries.forEach((entry) => destroyPeer(entry?.peer, label));
    return [];
};

export const stopMediaStream = (mediaStream) => {
    if (!mediaStream) {
        return;
    }

    mediaStream.getTracks().forEach((track) => {
        track.stop();
    });
};

export const bindSocketEvents = (socket, listeners) => {
    listeners.forEach(({ event, handler, once }) => {
        if (once) {
            socket.once(event, handler);
            return;
        }

        socket.on(event, handler);
    });

    return () => {
        listeners.forEach(({ event, handler }) => {
            socket.off(event, handler);
        });
    };
};

export const emitReadinessWithRetry = (
    socket,
    event,
    payload,
    { delays = [0, 800, 2000, 4000], acknowledgementTimeout = 1200 } = {}
) => {
    let cancelled = false;
    const timers = new Set();

    const schedule = (attempt) => {
        if (cancelled || attempt >= delays.length) return;
        const timer = setTimeout(() => {
            timers.delete(timer);
            if (cancelled) return;
            if (!socket.connected) {
                schedule(attempt + 1);
                return;
            }

            let acknowledged = false;
            const acknowledgementTimer = setTimeout(() => {
                timers.delete(acknowledgementTimer);
                if (!acknowledged) schedule(attempt + 1);
            }, acknowledgementTimeout);
            timers.add(acknowledgementTimer);

            socket.emit(event, { ...payload, attempt: attempt + 1 }, (response = {}) => {
                if (cancelled || acknowledged) return;
                acknowledged = true;
                clearTimeout(acknowledgementTimer);
                timers.delete(acknowledgementTimer);
                if (response.status !== 'ok') schedule(attempt + 1);
            });
        }, delays[attempt]);
        timers.add(timer);
    };

    schedule(0);
    return () => {
        cancelled = true;
        timers.forEach(clearTimeout);
        timers.clear();
    };
};
